// =============================================================================
// Integration anomalies (actividad sin fichaje)
// =============================================================================
import { apiClient } from './http';

export interface ActivityAnomaly {
  id: number;
  user_id: number;
  user_name?: string | null;
  source: string;
  started_at: string;
  ended_at: string | null;
  worksite_code: string | null;
}

export async function getActivityAnomalies(): Promise<ActivityAnomaly[]> {
  const response = await apiClient.get<ActivityAnomaly[]>('/integration/anomalies');
  return response.data;
}

export async function reviewAnomaly(id: number): Promise<void> {
  await apiClient.post(`/integration/anomalies/${id}/review`);
}
